import { HelperResult } from '@openclassrooms/sdk-web';
import type { TrainingProgramRecommendation } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useTrainingProgramRecommendations } = getCRUDHooks({
  entityName: 'userTrainingProgramRecommendations',
  find: ({ userId }): HelperResult<TrainingProgramRecommendation[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).trainingProgramRecommendations.find(),
});

// eslint-disable-next-line import/prefer-default-export
export { useTrainingProgramRecommendations };
